import type { GetConversation200AllOfThreeMessagesItemRole } from './getConversation200AllOfThreeMessagesItemRole';

/**
 * 개별 대화 메시지 정보
 */
export type GetConversation200AllOfThreeMessagesItem = {
  /**
   * 응답 토큰 수
   * @nullable
   */
  completionTokens?: number | null;
  /** 메시지 내용 */
  content: string;
  /**
   * 대화 ID
   * @nullable
   */
  conversationId?: string | null;
  /**
   * 생성 시각
   * @nullable
   */
  createdAt?: string | null;
  /**
   * 메시지 ID
   * @nullable
   */
  id?: string | null;
  /**
   * 사용된 모델 정보
   * @nullable
   */
  model?: string | null;
  /**
   * 프롬프트 토큰 수
   * @nullable
   */
  promptTokens?: number | null;
  /** 메시지 역할 */
  role: GetConversation200AllOfThreeMessagesItemRole;
  /**
   * 총 토큰 수
   * @nullable
   */
  totalTokens?: number | null;
};
